import React from 'react';
import styled from 'styled-components';

const StyledAnimatedLink = styled.a`
    display: inline-block;
    color: #000;
    text-decoration: none;

    &::after {
        content: '';
        display: block;
        position: relative;
        top: -10px;
        height: 8px;

        width: 100%;
        border-bottom: solid 2px #001eff;
       
    }

    &:hover {
        cursor: pointer;
        color: #001eff;
        &::after {
            border-color: #001eff;
            animation-duration: 1s;
            animation-name: changewidth;
            animation-iteration-count: infinite;
            animation-direction: alternate;
        }
    }

    @keyframes changewidth {
        from {
          width: 0%;
        }
        to {
          width: 100%;
        }
    }
`;

const AnimatedLink = (props) => {
    return ( 
        <StyledAnimatedLink {...props}></StyledAnimatedLink>
    );
}
 
export default AnimatedLink;